<template>
  <div>
    <header class="home">
      <div class="icon"
        :style="{
          backgroundImage: `url(${logoUrl})`
        }"
      ></div>
      <div class="placeholder"></div>
      <loginpage :open_at_start="$isMobile()" v-on:login="login" class="login"/>
    </header>
    <div class="body">
      <galerie :images="galerie_images"/>
    </div>
    <div>
      <article-with-image :image="{image: require('../images/enwatmon-homepage/Hochbehälter2_iphone12black_portrait.png'), animation: true}" 
          :layout="{height: 300}"
          :content="`
          <p>Hochbehälter immer dabei</p>
          <div>Mit EnwatMon haben sie, ortsunabhänig immer einen vollen Überblick über Ihre Wasserversorgung</div>`"/>

      <article-with-image 
        :image="{image: require('../images/enwatmon-homepage/uf overview_iphone12black_portrait.png'), animation: true}" 
        :layout="{height: 300, right:true}"
        :content="`
          <p>Störfälle, Warnungen und Serviceempfehlungen</p>
          <div>Mit Enwatmon erhalten Sie personalisierte Benachrichtigungen über Warnungen und Störfälle.<br> Wir bieten Ihnen außerdem auf Ihre Wasseraufbereitung zugeschnittene Serviceempfehlungen an</div>`"/>
 
    </div>
    <div style="height: 600px"></div>
    <div class="site footer">
        <a href="https://www.enwat.de/impressum">Impressum</a><a href="#">AGB</a><a href="#">Datenschutz</a>
    </div>
  </div>
</template>
<script>
import loginpage from '@/components/VueComponents/loginpage.vue'
import galerie from '@/components/VueComponents/galerie.vue'

import article_with_image from '@/components/VueComponents/article-with-image.vue'

export default {
  name: 'Home',
  components: {
    loginpage, galerie, 'article-with-image':article_with_image
  },
  computed:{
    
    logoUrl() {
      
      return process.env.VUE_APP_LOGO_PATH || '@/src/images/Enwatmon-Logo.svg';
    }
  },
  methods:{
    login({email, password}){
      console.log(email, password);
      this.$socket.emit('login', {username:email, password:password, isMobil: false, device_token: this.$cookies.get('device-token')})
    }
  },
  sockets:{
   
    connect_error(e){
      console.log(e)
    },
   login_failed(){
      alert('login failed')
    }, 


  },data(){
    return{
      galerie_images:[
        { image: require('../images/IMG_8639.jpg'), text: 'Enwatmon, das Wasserhaus in der Westentasche'},
        { image: require('../images/FAV_IMG_8669.jpg'), text: 'Zugriff auf Ihre Anlagen von Überall'},
        { image: require('../images/IMG_8828.jpg'), text: 'Bequem Daten auswerten \nund analysieren'},

      ]
    }
  }
}
</script>
<style>
header.home{
  display: flex;
  flex-direction: row;
  position: absolute;
  width: 100%;
  background-color: rgba(255,255,255,0.6);
  z-index: 100;
}
header.home .icon{
  flex: 1 0 0;
}
header.home .login{
  flex: 0 0 auto;
  margin-top: 10pt;
  margin-right: 10pt;
  margin-bottom: 10pt;
}
header.home .placeholder{
  flex: 2 0 0;
}
header.home .button:not(.login){
    background-color: rgba(255, 255, 255, 0.5);
    border-color: rgba(0, 0, 0, 0.8);
    color: rgba(0, 0, 0, 0.8);
}
header.home .toLogin .button:hover{
    color: rgba(255, 255, 255, 0.5);
    background-color: rgba(0, 0, 0, 0.8);
}

.site.footer{
  background: #292929;
  color: white;

  display: flex;
  flex-direction: row;
  padding: 10pt 0;
}
.site.footer a{
  flex: 1 0 0;
  font-size: var(--font1);
  text-align: center;
  color: white;
  text-decoration: none;
}
</style>